import React, { useState, useRef } from 'react';
import Tooltip from '@mui/material/Tooltip';
import Popper from '@mui/material/Popper';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Paper from '@mui/material/Paper';
import { WidgetsIcon } from '../icons';

const WidgetsDropdown = ({ widgetOptions, defaultSelected = [] }) => {
  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);

  const [selected, setSelected] = useState(() => {
    const initial = {};
    defaultSelected.forEach((label) => {
      initial[label] = true;
    });
    return initial;
  });

  const toggleDropdown = () => setOpen((prev) => !prev);
  const handleClickAway = () => setOpen(false);
  const handleCheckboxChange = (label) => {
    setSelected((prev) => ({
      ...prev,
      [label]: !prev[label],
    }));
  };

  const renderCheckbox = (label) => (
    <label
      key={label}
      className="d-flex align-items-center text-xs mb-1 gap-2"
    >
      <input
        type="checkbox"
        checked={selected[label] || false}
        onChange={() => handleCheckboxChange(label)}
        className="form-check-input me-2 w-20-px h-20-px"
      />
      {label}
    </label>
  );

  return (
    <ClickAwayListener onClickAway={handleClickAway} >
      <div style={{ marginLeft: '-10px' }}>
        <Tooltip title="Small Widgets" arrow placement="top">
          <button
            ref={anchorRef}
            onClick={toggleDropdown}
            className="btn btn-light"
            style={{
              background: '#fff',
              display: 'flex',
              padding: '6px 15px',
              alignItems: 'center',
              justifyContent: 'center',
              width: '50px',
              border: '1px solid rgba(229, 232, 235, 1)',
              borderRadius: '20px',
              height: '38px',
            }}
          >
            <WidgetsIcon />
          </button>
        </Tooltip>

        <Popper
          open={open}
          anchorEl={anchorRef.current}
          placement="bottom-start"
          modifiers={[
            {
              name: 'flip',
              enabled: true,
              options: {
                altBoundary: true,
                rootBoundary: 'viewport',
                padding: 8,
              },
            },
            {
              name: 'preventOverflow',
              enabled: true,
              options: {
                altAxis: true,
                tether: true,
              },
            },
          ]}
          style={{ zIndex: 999 }}
        >
          <Paper
            className="mt-2 p-3"
            elevation={3}
            style={{
              minWidth: '250px',
              maxHeight: '400px',
              overflowY: 'auto',
              borderRadius: '8px',
            }}
          >
            {Array.isArray(widgetOptions) ? (
              widgetOptions.map((label) => renderCheckbox(label))
            ) : (
              Object.entries(widgetOptions).map(([group, items]) => (
                <div key={group} className="mb-3">
                  <strong className="d-block mb-2 text-secondary text-xs">{group}</strong>
                  {items.map((label) => renderCheckbox(label))}
                </div>
              ))
            )}
          </Paper>
        </Popper>
      </div>
    </ClickAwayListener>
  );
};

export default WidgetsDropdown;
